export const ordersCardStyles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: "22px",
  },
  // title: {
  //   display: "flex",
  // },
  // icon: {
  //   marginRight: "16px",
  // },
  // text: {
  //   fontWeight: 500,
  //   fontSize: "22px",
  //   lineHeight: "25px",
  //   color: "#103B66",
  // },
  middle: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "24px",
  },
  middleOrders: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  middleEarnings: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  middleTitle: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "22px",
    color: "#6C7C8C",
  },
  middleAmt: {
    fontWeight: 500,
    fontSize: "17px",
    lineHeight: "22px",
    color: "#103B66",
  },
  bottom: {
    display: "flex",
    justifyContent: "space-between",
    color: "#21B8F9",
  },
  bottomText: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    textDecorationLine: "underline",
    cursor: "pointer",
  },
};
